export default function getNetworkUtilizationParams(value: number) {
  const load = (() => {
    if (value > 80) {
      return 'high';
    }

    if (value > 50) {
      return 'medium';
    }

    return 'low';
  })();

  const colors = {
    high: 'red.600',
    medium: 'orange.600',
    low: 'blue.600', // Veri5: brand-blue instead of green (chain runs at low utilization)
  };
  const color = colors[load];

  return {
    load,
    color,
  };
}
